(() => {
  if (customElements.get('futopia-mobile-film')) return;
  const compact = matchMedia('(max-width:699px)');
  class MobileFilm extends HTMLElement {
    connectedCallback() {
      this.dataset.filmBuild = '0929-R5';
      if (this.abort) {
        if (!this.dataset.filmStep) this.dataset.filmStep = 'guard:' + typeof this.abort;
        return;
      }
      try {
        this.initialize();
        this.dataset.filmStep = 'initialized';
      } catch (error) {
        this.dataset.filmState = 'init-error';
        this.dataset.filmInitError = error.name + ': ' + error.message;
        console.error('Fu.Topia mobile film [' + this.dataset.filmStep + ']', error);
      }
    }
    initialize() {
      this.dataset.filmStep = 'abort-controller';
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dataset.filmStep = 'find-elements';
      this.video = this.querySelector('video');
      this.stage = this.querySelector('.ft-film__stage');
      this.visual = this.querySelector('.ft-film__visual');
      this.progress = this.querySelector('.ft-film__progress span');
      this.playButton = this.querySelector('[data-play]');
      // WebKit owns HTMLElement.cue as a reflected boolean, not an element slot.
      this.filmCue = this.querySelector('[data-cue]');
      this.cueLabel = this.filmCue.textContent;
      this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.schedule = this.schedule.bind(this);
      this.configure = this.configure.bind(this);
      this.dataset.filmStep = 'motion-listener';
      this.reduce.addEventListener('change', this.configure, options);
      this.dataset.filmStep = 'window-listeners';
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', () => {
        if (this.width !== document.documentElement.clientWidth) this.measure();
        this.schedule();
      }, options);
      const v = this.video;
      this.dataset.filmStep = 'video-listeners';
      v.addEventListener('loadedmetadata', this.schedule, options);
      v.addEventListener('loadeddata', this.schedule, options);
      v.addEventListener('canplay', this.schedule, options);
      v.addEventListener('progress', this.schedule, options);
      v.addEventListener('seeked', () => {
        clearTimeout(this.seekWatch); this.seekWatch = 0;
        this.stallAttempts = 0;
        this.seekMs = performance.now() - this.seekStarted;
        // Reveal only a frame that belongs to the current scroll position.
        // loadeddata/playing can still carry the opening frame after a fast scroll.
        if (Math.abs(v.currentTime - this.desiredTime()) <= 1 / 30) this.frameReady();
        this.schedule();
      }, options);
      v.addEventListener('playing', () => {
        if (this.scrolling) { this.decoderPrimed = true; v.pause(); this.schedule(); }
        else this.playButton.textContent = this.playButton.dataset.pauseLabel;
      }, options);
      v.addEventListener('pause', () => {
        if (!this.scrolling) this.playButton.textContent = this.playButton.dataset.playLabel;
      }, options);
      v.addEventListener('error', () => { this.dataset.filmState = 'media-error'; }, options);
      this.dataset.filmStep = 'button-listeners';
      this.playButton.addEventListener('click', () => {
        if (this.scrolling) return;
        this.load();
        if (v.paused) v.play().catch(() => {}); else v.pause();
      }, options);
      this.querySelector('[data-skip]').addEventListener('click', () => {
        const target = document.querySelector('.shopify-section--featured-collections') || this.closest('.shopify-section').nextElementSibling;
        target?.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, options);
      const onGesture = event => {
        if (!this.scrolling || (!this.needsWake && (this.decoderPrimed || this.hasAttribute('data-ready'))) || event.target.closest('button,a,input,select,textarea')) return;
        const rect = this.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        this.prime(this.needsWake); this.schedule();
      };
      this.dataset.filmStep = 'gesture-listeners';
      window.addEventListener('touchstart', onGesture, { ...options, passive: true });
      window.addEventListener('touchend', onGesture, { ...options, passive: true });
      window.addEventListener('pointerdown', onGesture, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.suspend(); else this.resume();
      }, options);
      window.addEventListener('pagehide', () => this.suspend(), options);
      window.addEventListener('pageshow', event => {
        if (this.width !== document.documentElement.clientWidth) this.measure();
        if (event.persisted || this.suspended) this.resume(); else this.schedule();
      }, options);
      this.dataset.filmStep = 'font-ready';
      document.fonts?.ready.then(() => {
        if (this.isConnected) {
          // Late fonts must not change the scroll-to-time mapping mid-gesture.
          if (scrollY < 1) this.measure();
          this.schedule();
        }
      });
      this.configure();
    }
    configure() {
      this.dataset.filmStep = 'configure-reset';
      const v = this.video;
      this.generation = (this.generation || 0) + 1;
      this.mediaAbort?.abort(); clearTimeout(this.seekWatch);
      clearTimeout(this.primeWatch); this.seekWatch = 0;
      this.playTicket = (this.playTicket || 0) + 1;
      this.loadingPromise = null;
      this.priming = false; this.decoderPrimed = false;
      this.needsWake = false; this.suspended = false; this.stallAttempts = 0;
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      this.blobURL = null;
      v.pause(); v.removeAttribute('src'); v.removeAttribute('autoplay'); v.load();
      this.dataset.filmStep = 'configure-controls';
      this.scrolling = !this.reduce.matches;
      this.classList.toggle('is-scroll', this.scrolling);
      this.playButton.hidden = this.scrolling; this.filmCue.hidden = !this.scrolling;
      this.removeAttribute('data-ready'); this.dataset.filmState = this.scrolling ? 'loading' : 'reduced-motion';
      this.filmCue.textContent = this.scrolling ? 'Loading film…' : this.cueLabel;
      this.progress.style.transform = 'scaleX(0)';
      const poster = this.querySelector('.ft-film__poster');
      if (poster) v.poster = poster.currentSrc || poster.src;
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      this.dataset.filmStep = 'measure';
      this.measure();
      if (this.scrolling) {
        this.dataset.filmStep = 'source';
        this.load(); this.schedule();
      }
    }
    load() {
      if (this.video.getAttribute('src') || this.loadingPromise) return;
      const v = this.video, source = v.dataset.mobileSrc || v.dataset.src;
      this.sourceURL = source === v.dataset.optimizedFor ? (v.dataset.mobileScrollSrc || v.dataset.scrollSrc) : source;
      if (!this.scrolling) { v.preload = 'auto'; v.src = source; v.load(); return; }
      // Cache the unchanged MP4 before the first seek. Never swap sources after
      // revealing a frame: range downloads during reverse seeks stall on iOS.
      const generation = this.generation;
      const controller = this.mediaAbort = new AbortController();
      this.dataset.filmTransport = 'downloading';
      const timeout = setTimeout(() => controller.abort(), 30000);
      this.loadingPromise = (async () => {
        let src = this.sourceURL, transport = 'direct';
        try {
          const response = await fetch(src, { signal: controller.signal, cache: 'force-cache' });
          if (!response.ok) throw new Error('Film download failed');
          const bytes = await response.arrayBuffer();
          if (generation !== this.generation || !this.isConnected) return;
          this.blobURL = URL.createObjectURL(new Blob([bytes], { type: 'video/mp4' }));
          src = this.blobURL; transport = 'cached-mp4';
        } catch (error) {
          if (generation !== this.generation || !this.isConnected) return;
          this.lastLoadError = error.name;
        } finally { clearTimeout(timeout); }
        if (generation !== this.generation || !this.isConnected) return;
        this.dataset.filmTransport = transport;
        v.preload = 'auto'; v.src = src; v.load();
        this.prime(); this.schedule();
      })();
    }
    suspend() {
      this.suspended = true;
      cancelAnimationFrame(this.raf); this.raf = 0;
      clearTimeout(this.seekWatch); clearTimeout(this.primeWatch);
      this.seekWatch = 0;
      this.playTicket = (this.playTicket || 0) + 1;
      this.priming = false;
      this.video.pause();
    }
    resume() {
      if (document.hidden || !this.isConnected || !this.scrolling) return;
      this.suspended = false;
      this.resumeCount = (this.resumeCount || 0) + 1;
      this.stallAttempts = 0;
      // Keep source, displayed frame and scroll mapping. A resumed WebKit
      // decoder may need play/pause even though data-ready is still present.
      this.needsWake = true;
      this.prime(true); this.schedule();
    }
    prime(force = false) {
      // One play promise at a time; once decoded, gestures only seek.
      if (!this.scrolling || document.hidden || this.priming || (!force && (this.decoderPrimed || this.hasAttribute('data-ready'))) || !this.video.getAttribute('src')) return;
      const v = this.video, generation = this.generation;
      const ticket = this.playTicket = (this.playTicket || 0) + 1;
      this.priming = true;
      clearTimeout(this.primeWatch);
      this.primeWatch = setTimeout(() => {
        if (ticket !== this.playTicket || !this.isConnected) return;
        this.playTicket++; this.priming = false; this.needsWake = true;
        v.pause(); this.schedule();
      }, 1200);
      v.muted = true;
      v.play().then(() => {
        if (!this.isConnected || generation !== this.generation || ticket !== this.playTicket) return;
        clearTimeout(this.primeWatch);
        this.priming = false;
        this.decoderPrimed = true; this.needsWake = false;
        v.pause(); v.removeAttribute('autoplay'); this.schedule();
      }).catch(error => {
        if (generation !== this.generation || ticket !== this.playTicket) return;
        clearTimeout(this.primeWatch);
        this.priming = false;
        if (force) this.needsWake = true;
        this.lastPlayError = error.name;
        this.schedule();
      });
    }
    frameReady() {
      if (this.video.readyState < 2) return;
      this.decoderPrimed = true;
      this.setAttribute('data-ready', ''); this.dataset.filmState = 'ready';
      this.filmCue.textContent = this.cueLabel;
      this.video.removeAttribute('autoplay');
    }
    measure() {
      this.width = document.documentElement.clientWidth;
      for (const key of ['--film-height', '--film-visual-height', '--film-sticky-top']) this.style.removeProperty(key);
      this.style.setProperty('--film-copy-height', this.querySelector('.ft-film__copy').offsetHeight + 'px');
      const top = parseFloat(getComputedStyle(this.stage).top) || 0;
      this.start = this.getBoundingClientRect().top + scrollY - top;
      this.travel = Math.max(1, this.offsetHeight - this.stage.offsetHeight);
      if (this.scrolling) {
        this.style.setProperty('--film-height', this.offsetHeight + 'px');
        this.style.setProperty('--film-visual-height', this.visual.offsetHeight + 'px');
        this.style.setProperty('--film-sticky-top', top + 'px');
      }
    }
    schedule() {
      if (!this.scrolling || this.raf || document.hidden) return;
      this.raf = requestAnimationFrame(() => { this.raf = 0; this.draw(); });
    }
    draw() {
      if (!this.scrolling || this.priming || document.hidden) return;
      const v = this.video;
      const p = Math.max(0, Math.min(1, (scrollY - this.start) / this.travel));
      this.progress.style.transform = `scaleX(${p})`;
      if (v.readyState < 1 || !Number.isFinite(v.duration) || v.duration <= 0) return;
      this.targetTime = this.desiredTime();
      if (v.seeking) { if (!this.seekWatch) this.watchSeek(); return; }
      if (Math.abs(v.currentTime - this.targetTime) < 1 / 60 && this.hasAttribute('data-ready')) return;
      this.seekStarted = performance.now();
      try {
        v.currentTime = this.targetTime;
        this.watchSeek();
      } catch (error) { this.lastSeekError = error.name; }
    }
    watchSeek() {
      clearTimeout(this.seekWatch);
      this.seekWatch = setTimeout(() => {
        this.seekWatch = 0;
        if (!this.isConnected || !this.scrolling || document.hidden) return;
        const v = this.video;
        if (v.seeking) {
          this.stallAttempts = (this.stallAttempts || 0) + 1;
          this.needsWake = true;
          if (this.stallAttempts <= 2) {
            this.seekRecoveries = (this.seekRecoveries || 0) + 1;
            this.prime(true);
            this.watchSeek();
          }
          return;
        }
        if (Math.abs(v.currentTime - this.desiredTime()) <= 1 / 30) this.frameReady();
        this.schedule();
      }, 800);
    }
    desiredTime() {
      const p = Math.max(0, Math.min(1, (scrollY - this.start) / this.travel));
      const lastFrame = Math.max(0, Math.ceil(this.video.duration * 30) - 1);
      return Math.max(0.001, Math.round(p * lastFrame) / 30);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.generation = (this.generation || 0) + 1;
      this.mediaAbort?.abort(); clearTimeout(this.seekWatch);
      clearTimeout(this.primeWatch); this.playTicket = (this.playTicket || 0) + 1;
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      this.blobURL = null; this.loadingPromise = null;
      cancelAnimationFrame(this.raf); this.raf = 0;
      this.video?.pause();
    }
  }
  customElements.define('futopia-mobile-film', MobileFilm);
  const route = (root = document) => {
    const targetTag = compact.matches ? 'futopia-mobile-film' : 'futopia-welcome-film';
    root.querySelectorAll('futopia-welcome-film,futopia-mobile-film').forEach(old => {
      // Width selects the experience: phone scroll, tablet/desktop autoplay.
      if (!compact.matches) old.dataset.mode = 'auto';
      if (old.localName === targetTag) return;
      const next = document.createElement(targetTag);
      for (const attr of old.attributes) if (!['style', 'data-ready', 'data-film-state'].includes(attr.name)) next.setAttribute(attr.name, attr.value);
      next.classList.remove('is-scroll');
      const children = [...old.childNodes].map(node => node.cloneNode(true));
      next.append(...children);
      const video = next.querySelector('video');
      for (const attr of ['src', 'autoplay', 'poster']) video.removeAttribute(attr);
      video.preload = 'none';
      old.replaceWith(next);
      if (targetTag === 'futopia-mobile-film') next.dataset.filmRouted = '0929-R5';
    });
  };
  route();
  compact.addEventListener('change', () => route());
  document.addEventListener('shopify:section:load', event => route(event.target));
})();
